/* pageHome.js */

const pageConfig = {
  initialScene: 'home',
  navigationMode: 'spa',
  scenePageMap: {
    home: '/',
    market: '/market',
    catering: '/catering',
    about: '/about',
    games: '/games',
    boutique: '/boutique'
  },
  prefetchScenes: ['market', 'catering', 'about', 'games', 'boutique']
};

window.__BUBAR_PAGE__ = pageConfig;
import('../core/page.js').catch(err => console.error('Failed to load page runtime', err));

let homeLogoStageAnnounced = false;

function setHomeLogoVisibility(sceneName) {
  const logoOverlay = document.getElementById('home-logo-overlay');
  if (!logoOverlay) return;
  logoOverlay.classList.toggle('open', sceneName === 'home');
}

function announceHomeLogoStageReady() {
  if (homeLogoStageAnnounced) return;
  homeLogoStageAnnounced = true;
  window.dispatchEvent(new CustomEvent('home-logo-stage-ready'));
}

function hasLayoutClass() {
  return (
    document.body.classList.contains('is-mobile') || document.body.classList.contains('is-desktop')
  );
}

function setInitialHomeLogoVisibility() {
  if (hasLayoutClass()) {
    setHomeLogoVisibility('home');
    requestAnimationFrame(announceHomeLogoStageReady);
    return;
  }
  requestAnimationFrame(setInitialHomeLogoVisibility);
}

// Show logo when returning home via any path (back button, mesh click, nav icon)
window.addEventListener('scene-loaded', event => {
  const sceneName = event.detail?.sceneName;
  if (sceneName === 'home') setHomeLogoVisibility('home');
});

setInitialHomeLogoVisibility();
